import { authenticated } from './WebRequest';
import { omitNil } from 'js/mylib/Utils';
import type {
  ApiThunk,
  BarcodeResolveParameters,
  BarcodeResolveResponse,
  BarcodeSearchResult,
  BarcodeSearchParameters,
} from './types/BarcodeActions';

export type {
  ApiThunk,
  BarcodeCommand,
  BarcodeResolveParameters,
  BarcodeResolveResponse,
  BarcodeResolvedAction,
  BarcodeSearchResult,
  BarcodeSearchParameters,
} from './types/BarcodeActions';

export function searchBarcodes(
  parameters: BarcodeSearchParameters
): ApiThunk<BarcodeSearchResult[]> {
  const { zoneid, ...params } = omitNil(parameters);
  return authenticated.get(`/query/zone/${zoneid}/barcodes/`, { params });
}

export function barcodeResolve(
  barcode: BarcodeResolveParameters['barcode']
): ApiThunk<BarcodeResolveResponse> {
  const params = omitNil<BarcodeResolveParameters>({ barcode });
  return authenticated.get('/query/barcode_resolve', { params });
}
